import { Modal } from "antd";
import React from "react";
import getName from "../../../../helpers/getName";

const RendrerWorkers = ({ currentWorkerId, workersList }) => {
  const workerObj = workersList.find(worker => worker.id === Number(currentWorkerId));
  const nameWorker = getName(workerObj);

  return (
    <div key={currentWorkerId}>
      <span style={{ fontWeight: 'bold' }}>{nameWorker}</span> <span>{`(${workerObj.speciality.trim()})`}</span>
    </div>
  )
}

const AllModal = ({ visible, currentValues = [], closeModal, workersList = [] }) => {

  return (
    <Modal
      visible={visible}
      title={<div style={{display: 'flex', justifyContent: 'center'}}>Исполнители</div>}
      footer={null}
      onCancel={closeModal}
     >
      <div style={{display: 'flex', flexDirection: 'column', gap: '5px', height: 'auto', maxHeight: '500px', overflowY: 'auto'}}>
        {currentValues?.map((value, key) => (
          <RendrerWorkers currentWorkerId={value} workersList={workersList} key={key} />
        ))}
      </div>
    </Modal>
  )
}

export default AllModal;